import { useTranslation } from "react-i18next";
import Button from "./ui/Button";
import { ButtonVariant } from "../types/constants";
import { Link } from "react-router-dom";

interface IntroSectionProps {
    titleKey: string;
    subtitleKey?: string;
    descriptionKey?: string;
    imgSrc: string;
    buttonTextKey?: string;
    buttonVariant?: ButtonVariant;
}

export default function IntroSection({
    titleKey,
    subtitleKey,
    descriptionKey,
    imgSrc,
    buttonTextKey,
    buttonVariant = ButtonVariant.PRIMARY,
}: IntroSectionProps) {
    const { t } = useTranslation();

    const classes = {
        titleWrapper: "mt-4 mb-8 lg:mb-10 font-normal text-text-300 text-lg md:text-xl lg:text-[21.5px]",
        subtitle: "font-geologica font-normal text-xl tracking-[0] text-text-300",
        img: "w-full h-[300px] md:h-[510px] lap:h-[550px] lg:max-w-[1280px] lg:h-[550px] rounded-lg object-cover mb-8 lg:mb-10 mx-auto",
        text: "text-text-300 text-base font-normal w-full md:w-full lap:w-[360px] xl:w-[460px] xl:text-right",
    };

    const renderFooter = () => {
        if (!buttonTextKey && !descriptionKey) return null;

        return (
            <Link to="/about">
                <div className="flex flex-col lap:flex-row lap:justify-between lap:items-center gap-4">
                    {buttonTextKey && <Button text={t(buttonTextKey)} variant={buttonVariant} />}
                    {descriptionKey && <p className={classes.text}>{t(descriptionKey)}</p>}
                </div>
            </Link>
        );
    };

    return (
        <div className="flex flex-col">
            <div className="w-full md:w-[600px] lap:w-[600px] xl:w-[700px] lg:w-[749px]">
                <div className={classes.titleWrapper}>
                    <h2 className={classes.subtitle}>{t(titleKey)}</h2>
                    {subtitleKey && <p className="text-text-300">{t(subtitleKey)}</p>}
                </div>
            </div>

            <img src={imgSrc} alt="intro" className={classes.img} />

            {renderFooter()}
        </div>
    );
}
